import { useBrand } from './useBrand'

/** Props for the Logo component. */
interface LogoProps {
  className?: string
  height?: number
}

/** Renders the active brand's logo image. */
export const Logo = ({ className, height = 32 }: LogoProps) => {
  const brand = useBrand()

  return (
    <img
      src={brand.logoUrl}
      alt={`${brand.name} logo`}
      className={className}
      style={{ display: 'block', height: `${height}px`, width: 'auto' }}
    />
  )
}
